import script from "./TutorialCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialCenter.vue?vue&type=script&setup=true&lang=js"

import "./TutorialCenter.vue?vue&type=style&index=0&id=5a0c33b1&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0c33b1"]])

export default __exports__